const clientReducer = (state = [], action) => {
    switch (action.type) {
        case 'SET_CLIENTS':
            const newState = action.payload;
            return newState;
        case 'SET_CLIENT':
            const newClient = action.payload;
            return newClient;
        case 'UNSET_CLIENTS':
            return [];
        default:
            return state;
    }
};

export default clientReducer;